import { PoliciesDataType } from 'domain/shared/compliance';
import { NotificationsState } from 'infrastructure/notification/redux/reducer';

type PolicyNotificationsState = {
  notifications?: NotificationsState;
};

export const selectPolicyNotifications = (state: PolicyNotificationsState): PoliciesDataType[] =>
  Array.isArray(state.notifications?.POLICY) ? (state.notifications.POLICY as PoliciesDataType[]) : [];
